import { OptionsType } from '@/components/GenericOption'
import { Money } from '@/lib/definitions/api.types'
import {
  DDoSPrefix,
  DDoSPrefixSize,
  DDoSPrefixType,
  BandwidthOptions,
  PortSpeed,
  Prefix,
  ContractTerm,
} from '@/pages/ServiceWizard/ServiceWizard.types'

export const portSpeedOptions: PortSpeed[] = [
  {
    id: 1,
    speedInMbps: 1000,
    speed: 1,
    unit: 'Gbps',
    type: '1G-LX',
    name: '1G-LX (SFP)',
  },
  {
    id: 2,
    speedInMbps: 10000,
    speed: 10,
    unit: 'Gbps',
    type: '10G-LR',
    name: '10G-LR (SFP+)',
  },
  {
    id: 3,
    speedInMbps: 25000,
    speed: 25,
    unit: 'Gbps',
    type: '25G-LR',
    name: '25G-LR (SFP28)',
  },
  {
    id: 4,
    speedInMbps: 100000,
    speed: 100,
    unit: 'Gbps',
    type: '100G-LR4',
    name: '100G-LR4 (QSFP28)',
  },
  {
    id: 5,
    speedInMbps: 100000,
    speed: 100,
    unit: 'Gbps',
    type: '100G-LR1',
    name: '100G-LR1 (QSFP28)',
  },
  {
    id: 6,
    speedInMbps: 400000,
    speed: 400,
    unit: 'Gbps',
    type: '400G-LR4',
    name: '400G-LR4 (OSFP/QSFP-DD)',
  },
]

export const prefixV4: Prefix[] = [
  {
    id: 31,
    addresses: 2,
    isRecommended: true,
    note: 'Special case according to RFC 3021',
  },
  {
    id: 30,
    addresses: 4,
  },
  { id: 29, addresses: 8 },
  { id: 28, addresses: 16 },
  { id: 27, addresses: 32 },
  { id: 26, addresses: 64 },
  { id: 25, addresses: 128 },
]

export const prefixV6: Prefix[] = [
  {
    id: 127,
    addresses: 2,
    isRecommended: true,
    note: 'Special case according to RFC 3021',
  },
  {
    id: 126,
    addresses: 4,
  },
  { id: 125, addresses: 8 },
  { id: 124, addresses: 16 },
  { id: 123, addresses: 32 },
  { id: 122, addresses: 64 },
  { id: 121, addresses: 128 },
  { id: 120, addresses: 256 },
]

export const BandwidthValues: BandwidthOptions = {
  1: [100, 200, 300, 400, 600, 800, 1000],
  10: [1000, 2000, 3000, 4000, 6000, 8000, 10000],
  25: [2500, 5000, 7500, 10000, 15000, 20000, 25000],
  100: [10000, 20000, 30000, 40000, 60000, 80000, 100000],
  400: [40000, 80000, 120000, 160000, 240000, 320000, 400000],
}

export const contractTerms: ContractTerm[] = [
  { label: '1 Month', label_short: '1M', period: 1 },
  { label: '12 Months', label_short: '12M', period: 12 },
  { label: '24 Months', label_short: '24M', period: 24 },
  { label: '36 Months', label_short: '36M', period: 36 },
]

export const bgpTypeOptions: OptionsType[] = [
  { value: 'FULL_TABLE', label: 'Full Routing Table' },
  { value: 'DEFAULT_ROUTE', label: 'Default Route' },
  { value: 'FT_DR', label: 'Full Routing Table and Default Route' },
]

export const emptyMrcNrcValue: Money = {
  amount: '0',
  currency: 'EUR',
  display: '0.00 EUR',
}

export const defaultDDoSPrefixesList: DDoSPrefix[] = [
  {
    count: 4,
    type: DDoSPrefixType.IPv4,
    size: DDoSPrefixSize.PLUS,
    term: '12M',
  },
  {
    count: 1,
    type: DDoSPrefixType.IPv6,
    size: DDoSPrefixSize.PREMIUM,
    term: '24M',
  },
]

export const ddosProtectionSizesPlans = [
  {
    size: DDoSPrefixSize.PLUS,
    benefits: [
      'Lorem ipsum dolor sit amet',
      'Consectetur adipiscing elit',
      'Sed do eiusmod tempor',
    ],
  },
  {
    size: DDoSPrefixSize.PREMIUM,
    benefits: [
      'Lorem ipsum dolor sit amet',
      'Consectetur adipiscing elit',
      'Sed do eiusmod tempor',
      'Gives you wings',
    ],
  },
  {
    size: DDoSPrefixSize.ENTERPRISE,
    benefits: [
      'Lorem ipsum dolor sit amet',
      'Consectetur adipiscing elit',
      'Sed do eiusmod tempor',
      'Incididunt ut labore et dolore',
      'Hoch die Hände, Wochenende',
    ],
  },
]

export const mockLocations = {
  results: [
    {
      location: {
        id: 2922,
        name: 'AAR1-DK',
        description: 'Fuzion Aarhus',
        line1: 'Silkeborgvej 53',
        line2: '',
        city: {
          name: 'Aarhus',
          country: {
            name: 'Denmark',
            short_name: 'DK',
            is_eu_country: true,
          },
        },
        postal_code: '8000',
        latitude: 56.155695,
        longitude: 10.177281,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 2925,
        name: 'AAR2-DK',
        description: 'Fuzion Aarhus',
        line1: 'Silkeborgvej 53',
        line2: '',
        city: {
          name: 'Aarhus',
          country: {
            name: 'Denmark',
            short_name: 'DK',
            is_eu_country: true,
          },
        },
        postal_code: '8000',
        latitude: 56.155695,
        longitude: 10.177281,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 54,
        name: 'AHR1-DE',
        description: 'Datacenter One HAM1',
        line1: 'Carl-Backhaus-Str. 21c',
        line2: '',
        city: {
          name: 'Ahrensburg',
          country: {
            name: 'Germany',
            short_name: 'DE',
            is_eu_country: true,
          },
        },
        postal_code: '22926',
        latitude: 53.678625,
        longitude: 10.267915,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 15,
        name: 'AMS1-NL',
        description: 'Digital Realty Amsterdam AMS9/17',
        line1: 'Science Park 121',
        line2: '',
        city: {
          name: 'Amsterdam',
          country: {
            name: 'Netherlands',
            short_name: 'NL',
            is_eu_country: true,
          },
        },
        postal_code: '1098XG',
        latitude: 52.356671,
        longitude: 4.952501,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 16,
        name: 'AMS2-NL',
        description: 'NIKHEF (Science Park)',
        line1: 'Science Park 105',
        line2: '',
        city: {
          name: 'Amsterdam',
          country: {
            name: 'Netherlands',
            short_name: 'NL',
            is_eu_country: true,
          },
        },
        postal_code: '1098XG',
        latitude: 52.356394,
        longitude: 4.950837,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 45,
        name: 'ASH1-US',
        description: 'Equinix DC1-DC15, DC21 - Ashburn',
        line1: '21715 Filigree Ct, Building F',
        line2: '',
        city: {
          name: 'Ashburn',
          country: {
            name: 'United States of America',
            short_name: 'US',
            is_eu_country: false,
          },
        },
        postal_code: '20147',
        latitude: 39.016494,
        longitude: -77.461837,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 47,
        name: 'BER12-DE',
        description: 'NTT Berlin 2 Data Center (BER2)',
        line1: 'Lankwitzer Str. 45-47',
        line2: '',
        city: {
          name: 'Berlin',
          country: {
            name: 'Germany',
            short_name: 'DE',
            is_eu_country: true,
          },
        },
        postal_code: '12107',
        latitude: 52.440344,
        longitude: 13.367632,
        status: 'Planned',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 1,
        name: 'BER1-DE',
        description: 'IPB CarrierColo Berlin Luetzowstrasse (site B)',
        line1: 'L\u00fctzowstr. 105',
        line2: '',
        city: {
          name: 'Berlin',
          country: {
            name: 'Germany',
            short_name: 'DE',
            is_eu_country: true,
          },
        },
        postal_code: '10785',
        latitude: 52.50204,
        longitude: 13.36942,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 2,
        name: 'BER2-DE',
        description: 'IPB CarrierColo Berlin Kitzingstrasse (site K)',
        line1: 'Kitzingstr. 15',
        line2: '',
        city: {
          name: 'Berlin',
          country: {
            name: 'Germany',
            short_name: 'DE',
            is_eu_country: true,
          },
        },
        postal_code: '12277',
        latitude: 52.43269,
        longitude: 13.371285,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 3,
        name: 'BER3-DE',
        description: 'NTT Berlin 1 Data Center (BER1)',
        line1: 'Nonnendammallee 15',
        line2: '',
        city: {
          name: 'Berlin',
          country: {
            name: 'Germany',
            short_name: 'DE',
            is_eu_country: true,
          },
        },
        postal_code: '13599',
        latitude: 52.538195,
        longitude: 13.235402,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 4,
        name: 'BER4-DE',
        description: 'Lumen Berlin - Gradestr. 60',
        line1: 'Gradestrasse 60',
        line2: '',
        city: {
          name: 'Berlin',
          country: {
            name: 'Germany',
            short_name: 'DE',
            is_eu_country: true,
          },
        },
        postal_code: '12347',
        latitude: 52.452957,
        longitude: 13.425985,
        status: 'Planned',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 52,
        name: 'BUD1-HU',
        description: 'BIX Building (Victor Hugo street)',
        line1: 'Victor Hugo utca 18-22',
        line2: '',
        city: {
          name: 'Budapest',
          country: {
            name: 'Hungary',
            short_name: 'HU',
            is_eu_country: true,
          },
        },
        postal_code: '1132',
        latitude: 47.517956,
        longitude: 19.052928,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
    {
      location: {
        id: 2919,
        name: 'BUH1-RO',
        description: 'NXDATA-1 Bucharest incl. NXDATA-2 via XC',
        line1: '8 Bulevardul Dimitrie Pompeiu',
        line2: '',
        city: {
          name: 'Bucuresti',
          country: {
            name: 'Romania',
            short_name: 'RO',
            is_eu_country: true,
          },
        },
        postal_code: '020337',
        latitude: 44.481916,
        longitude: 26.120789,
        status: 'Active',
        planned_rfs: null,
        type: 'General',
        bandwidth: 400000,
        supplier_name: null,
        extension_handover: null,
      },
      search_point_distance: null,
      is_exact_match: null,
    },
  ],
  total_results: 47,
}
